import type { SVGProps } from "react";
const SvgGoogle = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
        <path
            fill="#4285F4"
            fillRule="evenodd"
            d="M512 261.689c0-21.05-1.743-36.41-5.514-52.338H261.24v95.003h143.954c-2.901 23.61-18.574 59.165-53.403 83.058l-.487 3.181 77.541 58.873 5.372.526C483.556 405.334 512 339.627 512 261.689"
            clipRule="evenodd"
        />
        <path
            fill="#34A853"
            fillRule="evenodd"
            d="M261.225 512c70.529 0 129.738-22.756 172.988-62.008l-82.432-62.58c-22.059 15.076-51.664 25.6-90.556 25.6-69.079 0-127.709-44.656-148.61-106.38l-3.062.255-80.635 61.156-1.055 2.872C70.819 454.541 159.056 512 261.225 512"
            clipRule="evenodd"
        />
        <path
            fill="#FBBC04"
            fillRule="evenodd"
            d="M112.615 306.621c-5.514-15.928-8.706-32.994-8.706-50.628 0-17.635 3.191-34.701 8.416-50.628l-.145-3.393-81.645-62.134-2.67 1.245C10.16 175.784.001 214.749.001 255.991s10.16 80.207 27.862 114.907l84.753-64.279z"
            clipRule="evenodd"
        />
        <path
            fill="#EA4335"
            fillRule="evenodd"
            d="M261.225 98.986c49.051 0 82.138 20.765 101.006 38.117l73.723-70.542C390.677 25.316 331.754.001 261.225.001 159.056.002 70.82 57.46 27.863 141.086l84.462 64.286c21.191-61.724 79.821-106.383 148.9-106.383v-.002Z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgGoogle;
